
<div class="container-fluid mb-3 p-0 dashboard__header position-relative">

    @if (isAndroid && !isAppUser){
    <div class="container position-rel">
<div class="row">
  <div class="col px-0">
  <a (click)="openOrInstallApp($event)" class="card p-3 app-card text-decoration-none">
    <div class="row">

    
    <div class="col-2 d-flex align-items-center">
      <img class="img-fluid rounded app-card__image" src="../assets/wh-app-logo.png">
    </div>
    <div class="col d-flex justify-content-center flex-column">
      <span class="app-card__header">Winning Hands Massage</span>
      <span class="app-card__subtitle">The app for Massge, Mindset & Wellness</span>
          <div class="col-auto d-flex align-items-center mt-2">
      <a class="app-card__button text-decoration-none">CONTINUE IN APP</a>
    </div>
    </div>

    </div>
  </a>
  </div>
</div>
</div>
  }

<div class="position-relative p-3">
<div class="client-menu client-menu-right">
    <button (click)="goBack();" mat-icon-button>
        <mat-icon>chevron_left</mat-icon>
    </button>
</div>
  <div class="row">
    <div class="col d-flex align-items-center justify-content-center">
      <img style="max-height: 60px;" class="img-fluid" src="../assets/Winning_Hands_Logo_Black-300x100.png">
    </div>
  </div>

<div class="client-menu">
  <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
  <mat-icon>menu</mat-icon>
</button>
<mat-menu #menu="matMenu">
  <button (click)="goToBook();" mat-menu-item>
    <mat-icon>today</mat-icon>
    <span>Book a massage</span>
  </button>
  <button (click)="goToLogin();" mat-menu-item>
    <mat-icon>account_circle</mat-icon>
    <span>Therapist login</span>
  </button>

</mat-menu>
</div>
</div>

</div>
<div class="container-fluid p-4 body__container">
  <div class="contianer">
      <router-outlet></router-outlet>
  </div>
</div>